<template>
  <div class="container">
    <div class="center">
      <img src="../../../static/images/neicebanBig.png" />
    </div>
    <div class="msg">
      因公司业务战略调整，本大模型产品自2025年03月18日起暂停服务。我们将在条件成熟时带着升级优化的功能与体验回归，感谢您的支持，期待再次为您服务！
    </div>
    <div class="gpt-content">
      <ul>
        <van-swipe :loop="false" :lazy-render="true" indicator-color="#001D7F">
          <van-swipe-item>
            <li>
              <div class="li-top">
                <div class="img">
                  <img src="../../../static/images/zhenliao.png" />
                  <span>医疗</span>
                </div>

                <p class="pOne">
                  <span class="p">
                    若您有了解和认识疾病的需求，并希望通过与Al的对话，快速获取中医辨证结果及开方等帮助，可以选择该对话模式。
                  </span>
                </p>
                <p class="pThree">
                  <span class="span">
                    <img src="../../../static/images/tishi.png" />
                    聊天技巧
                  </span>
                  <span class="spanTwo">
                    在该模式下，您需要在对话中详细描述所有的病情信息（性别、年龄、现病史、既往史等)，以便Al能给出准确的辨证结果及治疗建议。
                  </span>
                </p>
                <el-button type="primary" @click="changeRole('0')"
                  >开启对话</el-button
                >
              </div>
            </li>
          </van-swipe-item>

          <!-- <van-swipe-item>
            <li class="opacity">
              <div class="li-top">
                <div class="img">
                  <img src="../../../static/images/duolun_b.png" />
                  <span>知症</span>
                </div>

                <p>
                  <span class="p">
                    若您想通过身体的外候表现，认识疾病特定阶段的病理性质，并希望从与AI的对话中，提高判断证型、治则的能力，快速获取辅助诊断及开方等帮助，可以选择该对话模式。
                  </span>
                </p>
                <div class="video">
                  <img
                    @click="openVideoOne"
                    src="../../../static/images/yanshishipin.png"
                    alt=""
                  />
                  <span @click="openVideoOne">演示视频</span>
                </div>
                <p class="pThree">
                  <span class="span">
                    <img src="../../../static/images/tishi.png" />
                    聊天技巧
                  </span>
                  <span class="spanTwo">
                    在该模式下，您可以在对话中描述您的症状/体征信息，AI将通过您全部的叙述，确定病变的部位、原因、邪正关系等，最终给出准确的辨证结果/治疗建议。
                  </span>
                </p>
                <el-button disabled type="primary" @click="changeRole('3')"
                  >敬请期待···</el-button
                >
              </div>
            </li>
          </van-swipe-item> -->

          <van-swipe-item>
            <li>
              <div class="li-top">
                <div class="img">
                  <img src="../../../static/images/yangsheng.png" />
                  <span>养生</span>
                </div>

                <p class="pOne">
                  <span class="p">
                    若您对如何“保持健康、却病延年”感兴趣，可以选择该对话模式，通过与AI对话，以获取适合自己的养生方案。
                  </span>
                </p>
                <!-- <div class="video videoTwo">
                  <img
                    @click="openVideoTwo"
                    src="../../../static/images/yanshishipin.png"
                    alt=""
                  />
                  <span @click="openVideoTwo">演示视频</span>
                </div> -->
                <p class="pThree">
                  <span class="span">
                    <img src="../../../static/images/tishi.png" />
                    聊天技巧</span
                  >
                  <span class="spanTwo">
                    在该模式下，您可以在对话中描述想要获取的信息，AI将根据您提供的信息，最终给出诊断结果/养生建议。
                  </span>
                </p>
                <el-button type="primary" @click="changeRole('4')"
                  >开启对话</el-button
                >
              </div>
            </li>
          </van-swipe-item>
        </van-swipe>
      </ul>
    </div>

    <el-dialog v-model="internalTestFlag" width="460px" align-center>
      <div class="login-content2">
        <div class="top">
          <img src="../../../static/images/neicebanBig.png" />
        </div>
        <div class="center" style="padding-bottom: 0">
          <div class="userInfo" v-if="userInfo">
            <p v-if="reason">
              <span>审核不通过原由：</span>
              <span>{{ reason }}</span>
            </p>
          </div>
          <el-form
            ref="registerRuleForm"
            :model="internalTestInfo"
            :rules="registerRules"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="line">
              <el-form-item label="医疗机构名称" prop="hospital">
                <el-input
                  v-model="internalTestInfo.hospital"
                  placeholder="请填写医疗机构名称"
                />
              </el-form-item>
            </div>

            <div class="line">
              <el-form-item label="医疗机构地址" prop="address">
                <el-input
                  v-model="internalTestInfo.address"
                  placeholder="请填写医疗机构地址"
                />
              </el-form-item>
            </div>

            <div class="line">
              <el-form-item label="您的职务" prop="title">
                <el-input
                  v-model="internalTestInfo.title"
                  placeholder="请填写您的职务"
                />
              </el-form-item>
            </div>
            <div class="line license">
              <el-form-item label="上传医疗机构执业许可证" prop="cert">
                <div class="licenseImg">
                  <img src="../../../static/images/shiyitu.jpg" alt="" />
                  <div class="shiyituText">示意图</div>
                </div>
                <div class="user-con">
                  <van-uploader
                    v-model="imageUrlList"
                    class="avatar-uploader"
                    :max-count="1"
                    :after-read="getFile"
                    @delete="deleteImg"
                    accept=".png,.PNG,.JPG,.jpg,jpeg,.JPEG"
                  >
                    <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
                    <el-icon class="avatar-uploader-icon">
                      <Plus />
                    </el-icon>
                  </van-uploader>
                </div>
              </el-form-item>
            </div>

            <div class="line login-line">
              <div class="cancel-btn" @click="cancel">取消</div>
              <div class="cancel-btn" @click="submitForm">提交机构信息</div>
            </div>
            <!-- <div class="registerMsg">
              <span>已有账号?</span>
              <span @click="goLogin">立即登录</span>
            </div> -->
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="请预先选择疾病分类："
      v-model="multipleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content single">
        <ul>
          <li
            v-for="(item, index) in multipleIllList"
            :key="index"
            @click="goMultipleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      title="请预先选择疾病分类："
      v-model="singleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content">
        <ul>
          <li
            v-for="(item, index) in singleIllList"
            :key="index"
            @click="goSingleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  defineEmits,
  ref,
  //defineProps
} from "vue";

import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
//import { useStore } from 'vuex' // 引入useStore 方法
const router = useRouter();
const route = useRoute();
//const store = useStore()  // 该方法用于返回store 实例
const uniHttp = getCurrentInstance().appContext.config.globalProperties;
const globalImgPath = uniHttp.globalImgPath;
const registerRuleForm = ref(null); // 注册form表单
const emit = defineEmits(["getConversateList", "getRole"]);

const data = reactive({
  userInfo: {},
  identityRole: 1,
  chartVal: "",
  conversationDetail: {},
  conversationId: 0,
  role: -1,
  isCollapse: true,
  multipleDialogueFlag: false,
  singleDialogueFlag: false,
  singleIllList: [
    {
      name: "冠心病心绞痛",
      id: 0,
    },
    {
      name: "痛经",
      id: 1,
    },
  ],
  multipleIllList: [
    {
      name: "胃脘痛",
      id: 0,
    },
  ],
  internalTestFlag: false,
  internalTestInfo: {
    hospital: "",
    address: "",
    title: "", //职务
    cert: "",
  },
  imageUrl: "",
  imageUrlList: [],
  registerRules: {
    hospital: [
      {
        required: true,
        message: "请填写医疗机构名称",
        trigger: "blur",
      },
    ],

    title: [
      {
        required: true,
        message: "请填写您的职务",
        trigger: "blur",
      },
    ],
    cert: [
      {
        required: true,
        message: "请上传您的医疗机构执业许可证",
        trigger: "blur",
      },
    ],
  },
  reason: "", //审核不通过原因
  uploadCertFlag: false,
});

//使用toRefs解构
const {
  multipleDialogueFlag,
  singleDialogueFlag,
  multipleIllList,
  singleIllList,
  internalTestFlag,
  imageUrlList,
  registerRules,
  internalTestInfo,
  userInfo,
  reason,
} = toRefs(data);

/* const props = defineProps({
		conversationDetail: {
			type: Object,
			default: NaN,
		}, 
		conversationId: {
			type: Number,
			default: 0,
		}
	}) */
//知症查看视频
/*
const openVideoOne = () => {
  window.open("https://pvvlg.xet.tech/s/4Bxa2");
};
*/
//养生查看视频
/*
const openVideoTwo = () => {
  window.open("https://pvvlg.xet.tech/s/E1qZk");
};
*/
const getUserInfo = () => {
  window.localStorage.setItem("gptLogin", 2); //只显示知病单轮
  data.conversationId = Number(route.query.conversationId);
  data.role = window.localStorage.getItem("role");
  data.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
  data.identityRole = data.userInfo.role;
  //data.conversationDetail = props.conversationDetail;
  emit("getConversateList", data.conversationId); //触发conversationId的变化 更新父组件
};
const getFile = (param) => {
  param.status = "uploading";
  param.message = "上传中...";
  var fileObj = param.file;
  const isLt20M = fileObj.size / 1024 / 1024 < 20;
  if (!isLt20M) {
    ElMessage({
      showClose: true,
      message: "上传文件的大小不能超过20M!",
      type: "error",
    });
    return false;
  }
  // FormData 对象
  data.fileData = new FormData();
  // 文件对象
  data.fileData.append("file", fileObj);
  uploadCert(param);
};
//上传证书
const uploadCert = (param) => {
  uniHttp
    .$multipartPost("business/user/upload/cert", data.fileData)
    .then((res) => {
      if (res.data.code == 0) {
        data.imageUrl = globalImgPath + res.data.data.path;
        data.internalTestInfo.cert = data.imageUrl;
        if (data.imageUrlList[0]) {
          data.imageUrlList[0].url = data.imageUrl;
        }
        param.status = "success";
        param.message = "";
        data.uploadCertFlag = true;
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};
//删除图片
const deleteImg = () => {
  data.imageUrl = "";
  //data.imageUrlList = [];
  data.internalTestInfo.cert = "";
  data.fileList = [];
  data.fileData = null;
  data.uploadCertFlag = false;
};

//取消
const cancel = () => {
  data.internalTestFlag = false;
  data.internalTestInfo.hospital = "";
  data.internalTestInfo.address = "";
  data.internalTestInfo.title = "";
  data.internalTestInfo.cert = "";
  data.imageUrl = "";
  data.imageUrlList = [];
};
//提交机构信息
const submitForm = () => {
  registerRuleForm.value.validate((valid) => {
    if (valid) {
      uniHttp
        .$applicationJson("business/user/reRegister", {
          hospital: data.internalTestInfo.hospital,
          address: data.internalTestInfo.address,
          title: data.internalTestInfo.title,
          cert: data.internalTestInfo.cert,
          userId: data.userInfo.id,
          role: data.userInfo.role,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 0) {
            ElMessage({
              showClose: true,
              message: "提交成功，等待审核中",
              type: "success",
            });
            data.internalTestFlag = false;
          } else {
            ElMessage({
              showClose: true,
              message: res.data.msg,
              type: "success",
            });
          }
        });
    } else {
      console.log("error submit!!");
      return false;
    }
  });
};

//切换知病单轮和多伦
const changeRole = (role) => {
  data.role = role;
  if (role == 0) {
    getUserInfoTwo();
  } else {
    getConversationList(role);
  }
  //conversationAdd('','','');
};

//获取状态信息
const getUserInfoTwo = () => {
  uniHttp.$applicationJson("business/user/info").then((res) => {
    // console.log(res);
    if (res.data.code == 0) {
      let mediStatus = res.data.data.mediStatus;
      data.userInfo = res.data.data;
      if (mediStatus == 0) {
        ElMessage({
          showClose: true,
          message: "资料已提交，等待审核中",
          type: "success",
          customClass: "custom-message",
        });
      }
      if (mediStatus == 1) {
        getConversationList(data.role);
      }
      if (mediStatus == 2) {
        data.reason = res.data.data.reason;
        data.internalTestInfo.hospital = res.data.data.hospital;
        data.internalTestInfo.address = res.data.data.address;
        data.internalTestInfo.title = res.data.data.title;
        data.internalTestInfo.cert = res.data.data.cert;
        data.imageUrl = res.data.data.cert;
        if (data.imageUrlList[0]) {
          data.imageUrlList[0].url = data.imageUrl;
        } else {
          data.imageUrlList.push({
            url: data.imageUrl,
          });
        }
        data.internalTestFlag = true;
      }
      if (mediStatus == 3) {
        data.internalTestFlag = true;
      }
    } else {
      if (res.status != 203 && res.status != 205) {
        ElMessage({
          showClose: true,
          message: res.data.msg,
          type: "error",
        });
      }
    }
  });
};

//获取标题列表
const getConversationList = (role) => {
  uniHttp
    .$applicationJson("business/conversation/paging", {
      current: 0,
      pageSize: 1000,
      params: {
        role: role,
      },
    })
    .then((res) => {
      if (res.data.code == 0) {
        const chartTitleList = res.data.data.records.reverse();
        if (chartTitleList.length == 0) {
          conversationAdd("", "", "");
        } else {
          if (
            chartTitleList[0].title == "" ||
            chartTitleList[0].title == null
          ) {
            let conversationId = chartTitleList[0].conversationId;
            window.localStorage.setItem("preQuestion", data.chartVal);
            router.push({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: "",
                illName: "",
                role: data.role,
              },
            });
          } else {
            conversationAdd("", "", "");
          }
        }
        window.localStorage.setItem("role", data.role);
        emit("getRole", data.role); //触发知病和养生role的变化 更新父组件
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//知病多伦
const goMultipleChart = (item) => {
  conversationAdd(item.name, "", item.name);
};
//知病单轮
const goSingleChart = (item) => {
  conversationAdd(item.name, "", item.name);
};
//新增标题
const conversationAdd = (name, question, illName) => {
  uniHttp
    .$applicationJson("business/conversation/add", {
      role: data.role,
      illName: illName,
    })
    .then((res) => {
      if (res.data.code == 0) {
        let conversationId = res.data.data.conversationId;
        conversationEdit(name, conversationId, question, illName);
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};
//编辑标题
const conversationEdit = (name, conversationId, question, illName) => {
  uniHttp
    .$applicationJson("business/conversation/edit", {
      conversationId: conversationId,
      title: name,
    })
    .then((res) => {
      if (res.data.code == 0) {
        emit("getConversateList", conversationId); //触发父组件获取标题列表
        emit("getRole", data.role); //触发父组件获取标题列表
        window.localStorage.setItem("preQuestion", data.chartVal);
        router.push({
          path: "/GptChart/GptChart",
          query: {
            conversationId: conversationId,
            question: question,
            illName: illName,
            role: data.role,
          },
        });
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

onMounted(() => {
  getUserInfo();
});
</script>

<style lang="less" scoped>
/deep/.el-message {
  max-width: 90%;
}
/deep/.el-message__content {
  line-height: 20px !important;
}
.container {
  width: calc(100% - 40px);
  padding: 0 20px;
  height: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: auto;

  .top {
    float: right;
    cursor: pointer;
    border: 1px solid #eee;
    height: 36px;
    line-height: 36px;
    border-radius: 5px;
    padding: 0 24px;
    margin-top: 20px;
    font-size: 14px;
    position: absolute;
    top: 20px;
    right: 40px;
  }

  .center {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    padding: 30px 0 0px 0;
    overflow: hidden;

    img {
      width: 80%;
      margin: 0 auto;
    }
  }
  .msg {
    width: 100%;
    text-align: justify;
    margin-top: 0.42rem;
    color: rgb(249, 48, 48);
    font-size: 0.26rem;
    line-height: 0.4rem;
    text-indent: 2em;
  }

  .gpt-content {
    width: 100%;
    margin-top: 50px;
    padding-bottom: 10px;
    /deep/ .van-swipe__track {
      padding-bottom: 0.8rem;
    }

    ul {
      width: 96%;
      margin: 0 auto;

      .van-swipe {
        width: 100%;
        /deep/ .van-swipe__indicator {
          width: 0.18rem;
          height: 0.18rem;
          background-color: #999;
        }
      }

      .van-swipe-item {
        height: 60%;
      }

      li {
        background: #ffffff;
        border-radius: 20px;
        border: 1px solid rgba(28, 62, 185, 0.5);
        padding: 25px 20px 20px 20px;
        margin: 0 5px;
        .li-top {
          width: 100%;
          margin-bottom: 10px;
          text-align: center;
          position: relative;
          .video {
            width: 100%;
            height: 0.5rem;
            display: flex;
            cursor: pointer;
            position: absolute;
            top: 3.5rem;
            font-size: 0.3rem;
            &.videoTwo {
              top: 3rem !important;
            }
            img {
              width: 0.36rem;
              height: 0.36rem;
              position: absolute;
              right: 1.5rem;
            }
            span {
              display: block;
              width: 1.4rem;
              height: 0.36rem;
              line-height: 0.36rem;
              position: absolute;
              right: 0.1rem;
            }
          }
          .img {
            margin: 0 auto;
            margin-bottom: 0.4rem;
            height: 0.8rem;
            text-align: center;
            width: 1.7rem;
            img {
              display: inline-block;
              width: 0.6rem;
              margin-top: 0.1rem;
              float: left;
            }
            span {
              display: inline-block;
              line-height: 0.8rem;
              height: 0.8rem;
              font-weight: bold;
              font-size: 0.48rem;
              margin-left: 0.1rem;
              float: left;
              width: 1rem;
            }
          }
          p {
            float: left;
            line-height: 0.48rem;
            margin-bottom: 20px;
            text-align: left;
            height: 2.4rem;
            width: 100%;
            font-size: 0.3rem;
            &.pOne {
              height: 2rem;
            }

            .p {
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical; // 避免压缩后删除此行
              -webkit-line-clamp: 5; // 显示省略号行数
            }
          }
          .pThree {
            height: 1.92rem;

            .span {
              display: inline-block;
              width: 100%;
              color: #1c3eb9;
              line-height: 24px;
              margin-bottom: 5px;
              img {
                float: left;
                width: 20px;
                margin-right: 3px;
              }
            }
            .spanTwo {
              height: 1.92rem;
              -webkit-box-orient: vertical; // 避免压缩后删除此行
              -webkit-line-clamp: 4; // 显示省略号行数
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
            }
          }

          .el-button {
            width: 100%;
            margin: 0 auto;
            text-align: center;
            background: #001d7f;
            border: 1px solid #001d7f;
            font-size: 16px;
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 20px;
            font-size: 0.3rem;
          }
        }
      }

      .opacity {
        opacity: 0.7;
        border: 1px solid #999;
        .li-top {
          .video {
            width: 100%;
            display: flex;
            cursor: pointer;
            position: absolute;
            top: 3.5rem;
            font-size: 0.3rem;
            img {
              width: 0.36rem;
              height: 0.36rem;
              position: absolute;
              right: 1.5rem;
            }
            span {
              display: block;
              width: 1.4rem;
              height: 0.36rem;
              line-height: 0.36rem;
              position: absolute;
              right: 0.1rem;
            }
          }
          .el-button {
            background: #999;
            border: 1px solid #999;
          }
        }
      }
    }
  }

  .container-content {
    width: 100%;

    .content-ul {
      width: 100%;
      max-width: 1280px;
      display: flex;
      margin: 0 auto;

      .content-ul-li {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        margin-right: 10px;

        &:nth-child(4) {
          margin-right: 0;
        }

        .list-ul {
          height: 100%;
          width: 100%;
          margin-top: 40px;

          .title {
            overflow: hidden;
            margin-bottom: 40px;

            img {
              display: block;
              width: 40px;
              margin: 0 auto;
            }

            p {
              text-align: center;
              margin-top: 10px;
            }
          }

          li {
            background: #f7f7f8;
            border-radius: 4px;
            line-height: 20px;
            width: 220px;
            padding: 10px 10px;
            margin: 0 auto 20px;
            cursor: pointer;

            @media (min-width: 1200px) {
              width: 200px;
            }

            @media screen and (min-width: 1200px) and (max-width: 1480px) {
              width: 220px;
            }

            @media (min-width: 1440px) {
              width: 240px;
            }
          }
        }
      }
    }
  }

  .chart-input {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1080px;
    margin: 40px auto;
    position: relative;

    .el-textarea {
      width: 90%;
      flex: 1;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/ .el-textarea__inner {
        min-height: 40px !important;
        padding: 8px 11px;
      }
    }

    .el-button {
      margin-left: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 33px;
      position: absolute;
      right: 10px;
      background: #1c3eb9;
      border: 1px solid #1c3eb9;
    }
  }

  @media screen and (min-width: 1000px) and (max-width: 1280px) {
    .chart-input {
      max-width: 880px;
    }
  }

  .login-content {
    height: 40px;

    ul {
      width: 230px;
      margin: 0 auto;

      li {
        float: left;
        line-height: 30px;
        width: 100px;
        border: 1px solid #409eff;
        margin-right: 10px;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
        background: #409eff;
        color: #fff;
      }
    }
  }

  .single {
    ul {
      width: 122px;
      margin: 0 auto;
    }
  }
  /deep/ .el-dialog {
    border-radius: 15px;
    width: 90%;
  }
  /deep/.el-dialog__body {
    padding-bottom: 20px;
  }
  /deep/.el-form-item__error {
    font-weight: normal;
  }
  .login-content2 {
    width: 100%;
    margin-bottom: 0;
    .top {
      width: 100%;
      height: auto;
      overflow: hidden;
      padding: 0;
      right: 0;
      border: none;

      img {
        width: 260px;
        margin: 0 auto;
      }

      span {
        color: #13171d;
        font-size: 40px;
        display: inline-block;
        line-height: 56px;
        float: left;
        margin-left: 10px;
      }
    }

    .center {
      margin-top: 10px;
      /deep/.el-form-item__label {
        font-weight: normal;
      }
      /deep/input::placeholder {
        font-weight: normal !important;
      }
      /deep/input {
        font-weight: normal !important;
      }
      .licenseImg {
        float: left;
        // margin-top: 8px;
        margin-right: 20px;
        img {
          width: 130px;
        }
        .shiyituText {
          width: 130px;
          text-align: center;
          font-weight: normal;
          font-size: 12px;
          color: #13171d;
        }
      }
      .user-con {
        padding-bottom: 10px;
        float: left;
        /deep/ .avatar-uploader {
          margin: 8px 40px 5px 0px;
          .avatar {
            width: 80%;
            display: block;
            // margin: 0 auto;
          }
          .el-upload {
            border: 1px dashed var(--el-border-color);
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            transition: var(--el-transition-duration-fast);
            &:hover {
              border-color: var(--el-color-primary);
            }
          }

          .el-icon.avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 80px;
            height: 80px;
            text-align: center;
            border: 1px dashed #ccc;
          }
        }
      }
      .userInfo {
        margin: 10px 0;
        p {
          span {
            float: left;
            width: 130px;
            line-height: 24px;
            font-size: 15px;
            font-weight: normal;
            // margin-bottom: 10px;
            &:nth-child(1) {
              color: red;
            }
            &:nth-child(2) {
              text-align: left;
              width: calc(100% - 130px);
            }
          }
        }
      }
      .el-form-item {
        display: block;

        /deep/ .el-form-item__label {
          justify-content: flex-start;
          width: 360px !important;
          display: block;
        }

        /deep/ .el-form-item__content {
          display: block;
          margin-left: 0px !important;
        }
      }

      .line {
        width: 100%;
        float: left;
        text-align: left;

        .nam {
          color: #13171d;
          line-height: 20px;
          width: 72px;
          display: block;
        }

        .border {
          display: block;
          width: 20px;
          height: 2px;
          background: #001d7f;
          margin-left: 16px;
        }

        .login-btn {
          width: 308px;
          height: 36px;
          background: #001d7f;
          border-radius: 5px;
          margin: 0 auto;
          line-height: 36px;
          text-align: center;
          color: #fff;
          font-size: 14px;
          cursor: pointer;
        }

        .line-line {
          padding: 5px 0;

          .color {
            color: red;
            margin-right: 2px;
            margin-top: 4px;
            float: left;
          }

          span {
            font-size: 14px;
          }
        }
      }

      .code {
        position: relative;

        .el-input {
          width: 100% !important;

          /deep/ .el-input__inner {
            width: 200px;
            overflow: hidden;
          }
        }

        .getCode {
          position: absolute;
          border-left: 1px solid #ccc;
          padding-left: 10px;
          color: #d65f4c;
          float: right;
          right: 10px;
          cursor: pointer;
        }
      }

      .login-line {
        text-align: center;
        border-top: 1px solid #f5f4f4;
        .cancel-btn {
          width: 120px;
          border-radius: 5px;
          margin: 0 auto;
          text-align: center;
          font-size: 14px;
          display: inline-block;
          height: 36px;
          margin-top: 20px;
          line-height: 36px;
          cursor: pointer;
          &:nth-child(1) {
            color: #001d7f;
            background: #fff;
            border: 1px solid #001d7f;
            margin-right: 30px;
          }
          &:nth-child(2) {
            color: #fff;
            background: #001d7f;
          }
        }

        .is-disabled {
          opacity: 0.8;
        }
      }
      .registerMsg {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
        span {
          &:nth-child(1) {
            margin-right: 10px;
            font-size: 14px;
          }
          &:nth-child(2) {
            color: #001d7f;
            cursor: pointer;
          }
        }
      }

      .phone {
        .el-input {
          width: 340px;
        }
      }

      .pwd {
        .el-input {
          width: 220px;
        }

        .btn {
          width: 100px;
          display: inline-block;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .checked {
        font-size: 12px;

        .el-checkbox {
          float: left;
        }

        .span {
          display: inline-block;
          line-height: 34px;
          float: left;
          margin-left: 5px;

          .color {
            color: #001d7f;
            cursor: pointer;
          }
        }
      }

      .login-line {
        // margin-top: 10px;
      }

      .checkbox {
        .el-checkbox {
          margin-right: 10px;
        }
      }

      .loginInfo {
        margin-top: 10px;
        width: 100%;
        float: left;
      }
    }
  }
}
</style>
